import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: {},      // { hubspot: { connected, accountId, connectedAt }, salesforce: {...} }
    loading: {},
    catalog: {},     // { hubspot: { id, label, authType, requiresSubdomain, logo, colors }, ... } from GET integrations/catalog
    error: null
};

export const integrationSlice = createSlice({
    name: 'integration',
    initialState,
    reducers: {
        setIntegrationStatus: (state, action) => {
            const { crm, data } = action.payload;
            return { ...state, status: { ...state.status, [crm]: data } };
        },
        setIntegrationLoading: (state, action) => {
            const { crm, loading } = action.payload;
            return { ...state, loading: { ...state.loading, [crm]: loading } };
        },
        setCrmCatalog: (state, action) => {
            const catalog = Object.fromEntries((action.payload || []).map(entry => [entry.id, entry]));
            return { ...state, catalog };
        },
        clearIntegration: () => {
            return initialState;
        }
    }
});

export const { setIntegrationStatus, setIntegrationLoading, setCrmCatalog, clearIntegration } = integrationSlice.actions;
export const selectIntegrationStatus = (crm) => (state) => state.integration.status[crm] || { connected: false, accountId: null, connectedAt: null };
export const selectIntegrationLoadingByCrm = (crm) => (state) => state.integration.loading[crm] ?? true;
export const selectCrmCatalog = (state) => state.integration.catalog;
export default integrationSlice.reducer;